module.exports = __webpack_public_path__ + "img/20250919143343249.e6bbcb4f.jpg";